<form [formGroup]="form" class="form">
  <div class="preamble">
    <h2>Exchange area</h2>
    @if (nextButtonClicked && !isExchangeAreaReferenceInputValid && form.dirty) {
      <div class="alert alert-warning">You must enter a valid exchange area reference number. An exchange area must be legally secured prior to clearing. Please call 135 VEG (135 834) if you need clarification about when an exchange area is required or how to legally secure an exchange area.</div>
    }
    <b>{{exchangeAreaTitle}}</b>
    <ul>
      @for (exchangeAreaQuestion of exchangeAreaQuestions; track exchangeAreaQuestion) {
        <li>
          <span [innerHtml]="exchangeAreaQuestion"></span>
        </li>
      }
    </ul>
  </div>
  @if (displayKoalaHabitatProtectionInfoMessage) {
    <div class="alert alert-info">
      <p>However, an exchange area is not required if the clearing is in a koala habitat area and an environmental offset for interfering with koala habitat has been legally secured for the extent of clearing.</p>
    </div>
  }
  <br>
    <fieldset>
      <ol class="questions">
        <li class="required">
          <label>
            <span class="label"><b>Does the clearing require an exchange area?</b></span>
            <abbr title="(required)" class="required">*</abbr>
          </label>
        </li>
        <li class="group">
          <ul class="choices">
            <li>
              <input type="radio" id="isExchangeAreaRequired-yes" [value]="true" formControlName="isExchangeAreaRequired" />
              <label for="isExchangeAreaRequired-yes">
                Yes
              </label>
            </li>
            <li>
              <input type="radio" id="isExchangeAreaRequired-no" [value]="false" formControlName="isExchangeAreaRequired" (click)="clearExchangeAreaReferenceNumber()" />
              <label for="isExchangeAreaRequired-no">
                No
              </label>
            </li>
          </ul>
        </li>
      </ol>
    </fieldset>

    @if (isExchangeAreaRequiredControl.value) {
      <div>
        <div class="alert alert-info">
          <p>An exchange area must be legally secured prior to clearing. The code outlines the specific requirements for securing exchange areas, including that the exchange area be made a Category A area.</p>
        </div>
        <p>The Exchange area reference number will be in the following format yyyy/xxxxxx e.g. 2025/123456.</p>
        <fieldset>
          <ol class="questions">
            <li class="required" [ngClass]="{'invalid': isExchangeAreaReferenceInputValid ? null: true }">
              <label for="reason">
                <span class="label">Enter Exchange Area reference number</span>
                <abbr title="(required)" class="required">*</abbr>
                @if (!isExchangeAreaReferenceInputValid) {
                  <em class="red-alert">Please enter in a valid format e.g 2022/123456.</em>
                }
                @if (!!exchangeAreaErrorMessage) {
                  <em class="red-alert">{{exchangeAreaErrorMessage}}</em>
                }
              </label>
              <input maxlength="15" step="any" required name="exchangeAreaReferenceNumber" id="exchangeAreaReferenceNumber" formControlName="exchangeAreaReferenceNumber" />
            </li>
          </ol>
        </fieldset>
      </div>
    }
    <li class="footer">
      <ul class="actions">
        <li>
          <input class="qg-btn btn-global-secondary" type="button" (click)="previous()" value="Previous" />
        </li>
        <li>
          <em><input class="qg-btn btn-primary" type="submit" (click)="next()" value="Next" /></em>
        </li>
      </ul>
    </li>
    <ul class="actions">
      <li>
        <a href (click)="cancel()">Cancel</a>
      </li>
    </ul>
  </form>
